<template>
  <div class="modal common-toast-wrapper">
    <div class="code">
      <img :src="qrCode" class="code-img">
      <div class="timer" style="color: aliceblue;">
        <span>{{ h }}</span>
        <span>{{ m }}</span>
        <span>{{ s }}</span>
      </div>
      <img src="./static/close.png" class="close" @click="close" />
    </div>
  </div>
</template>
<script>
import { chttp, apis } from '@/libs/interfaces';

export default {
  data() {
    return {
      hours: 1,
      minutes: 0,
      seconds: 0,
      h: '01',
      m: '00',
      s: '00',
      qrCode: require('./static/code_img.jpg'),
    };
  },
  computed: {
    unionid() {
      return this.$store.state.unionid;
    },
  },
  methods: {
    close() {
      this.$store.commit('SET_FANS_MODAL_VIP', false);
    },
    num(n) {
      return n < 10 ? `0${n}` : `${n}`;
    },
    timer() {
      const time = setInterval(() => {
        if (this.seconds === 0 && this.minutes === 0 && this.hours !== 0) {
          this.seconds = 59;
          this.minutes = 59;
          this.hours -= 1;
        } else if (this.seconds === 0 && this.minutes !== 0) {
          this.seconds = 59;
          this.minutes -= 1;
        } else if (this.minutes === 0 && this.seconds === 0) {
          this.seconds = 0;
          clearInterval(time);
        } else {
          this.seconds -= 1;
        }
        this.h = this.num(this.hours);
        this.m = this.num(this.minutes);
        this.s = this.num(this.seconds);
      }, 1000);
    },
    // 获取二维码信息
    async getQrCode() {
      const params = {
        unionid: this.unionid,
      };
      const res = await chttp.get(apis.qr_code, { params });
      if (res.errcode === 200) {
        this.qrCode = res.qr;
      }
    },
  },
  mounted() {
    this.getQrCode();
    this.timer();
  },
};
</script>
<style lang="scss" scoped>
.modal{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: $z_index_important;
  .code {
    width: 624px;
    height: 794px;
    background: url(static/vip_modal.png) no-repeat top center;
    background-size: 100% 100%;
    position: relative;
    .code-img {
      width:220px;
      height: 220px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 317px;
      border-radius: 20px;
    }
  }
  .timer {
    position: absolute;
    top: 208px;
    left: 90px;
    width: 448px;
    height: 66px;
    background: url('./static/timeBg.png') no-repeat;
    background-size: 100%;
    span{
      display: inline-block;
      width: 90px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      letter-spacing: 3px;
      color: #F2E6C6;
      font-size: 42px;
      margin-right: 35px;
      font-weight: bold;
    }
    i {
      display: inline-block;
      width: 15px;
      height: 45px;
      background: url(static/maohao.png) no-repeat center center;
      background-size: 15px 45px;
    }
  }
  .close {
    right: 0;
  }
}
</style>
